export const uniqueArray = (arrayOfSkus: string[]) => {
  const uniqueArray: string[] = [];
  arrayOfSkus.forEach((c) => {
    if (!uniqueArray.includes(c)) {
      uniqueArray.push(c);
    }
  });
  return uniqueArray;
};
